export default __webpack_public_path__ + "static/media/BLR30.8316afd0.jpg";